import type { CaixaResumo } from "../../../services/historicoCaixa"

export type HistoricoCaixaModel = {
    caixas: CaixaResumo[]
}

export const HistoricoCaixaInicial: HistoricoCaixaModel = {
    caixas: [],
}
